export default __webpack_public_path__ + "static/people-930cc4e0b3be930da35dd403b839b731.jpg";